import { z } from 'zod'

export const UserSchema = z.object({
  id: z.string().min(1),
  family_id: z.string().min(1),
  member_id: z.string().min(1).optional(),
  display_name: z.string().min(1),
  created_at: z.string(),
})
export type User = z.infer<typeof UserSchema>
